var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGuideMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-guideMap"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-guideMap",
    clipPath: "url(#clip-icon-guideMap)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(1.03 -1.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M620.8,803.63h-2.28a8.161,8.161,0,0,1,2.28,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M627.13,814.4a7.525,7.525,0,0,1-1.27,2.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 378.423,
    height: 233.032,
    rx: 116.516,
    transform: "translate(559.861 189.467)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M929.67,940.53H568.48a8.182,8.182,0,0,1-7.09-12.27L625.86,816.6a7.525,7.525,0,0,0,1.27-2.2l2.43-4.2.68-1.19a3.717,3.717,0,0,0,.25-1.38,3.991,3.991,0,0,0-3.42-3.96,3.689,3.689,0,0,0-.58-.04H620.8a8.161,8.161,0,0,0-2.28,0H476.4a7.991,7.991,0,0,0-6.62,6.99V932.53a8,8,0,0,1-8,8H147.97a8,8,0,0,1-8-8V618.72a8,8,0,0,1,8-8H269.48a8,8,0,0,0,7.4-7V474.15a8.016,8.016,0,0,0-6.33-6.86,164.914,164.914,0,0,1,35.62-326.21c90.23.7,163.63,74.71,163.61,164.94A164.967,164.967,0,0,1,339.26,467.29a8.012,8.012,0,0,0-6.38,7.43V603.21a8,8,0,0,0,6.85,7.51H461.78a8,8,0,0,1,8,8v121.5a8,8,0,0,0,7.16,7.41H662.31a7.993,7.993,0,0,0,5.31-3.36,8.758,8.758,0,0,0,.62-1.07c.01-.01.01-.01.01-.02l73.74-127.72a8.177,8.177,0,0,1,14.17,0l90.3,156.4,90.29,156.4A8.177,8.177,0,0,1,929.67,940.53Z",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGuideMap);
export default __webpack_public_path__ + "static/media/icon-guideMap.a86aae7e2eb76c66235bc0171194249f.svg";
export { ForwardRef as ReactComponent };